import { useEffect, useRef, useState } from "react";
import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";
import { Typography, TextField, Select, MenuItem, CircularProgress, Button } from "@mui/material";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import WarningIcon from '@mui/icons-material/Warning';

export function formatTEDDate(TEDDate: string): string{
    // NOTE: this is to manage both the old and new TED date format from the notice date
    if(TEDDate.length == 10){
        return TEDDate;
    }
    else{
        return TEDDate.substring(0, 4) + "-" + TEDDate.substring(4, 6) + "-" + TEDDate.substring(6, 8);
    }
}


export default function TEDDetails({ ted, handleCloseAndDelete, handleClose }){

    let linkRef = useRef("");
    let dateRef = useRef("");
    let titleRef = useRef("");
    let descriptionRef = useRef("");
    let typeRef = useRef("");

    let [isInStoryline, setIsInStoryline] = useState(null as null | boolean);

    useEffect(() => {
        StorylineServerProxy.checkLinksUnicity([ted.link]).then(includedLinks => setIsInStoryline(includedLinks.links.includes(ted.link)));
    }, []);


    function handleCreate(){
        let storyElement = {
            title: titleRef.current.value,
            link: linkRef.current.value,
            description: descriptionRef.current.value,
            type: typeRef.current.value,
            timestampFormatted: dateRef.current.value,
            timestamp: new Date(dateRef.current.value).getTime()
        }

        StorylineServerProxy.createStoryElement(storyElement).then(data => { });

        handleCloseAndDelete(ted);
    }

    function handleOpenInNewClicked(){
        window.open(linkRef.current.value, "child");
    }


        let description = "";
        description += "Title: " + ted.title + "\n"
        description += "Contracting body: " + ted.contractingBody + "\n"
        description += "Description: " + ted.shortDescription + "\n"
        description += "CPVs:" + "\n"
    
        if(ted.cpvCodes != null){
            for(const cpv of ted.cpvCodes){
                description += cpv.code + " " + cpv.description + "\n"
            }    
        }
    
        if(ted.type == "Contract award"){
            description += "Awarded to: " + "\n"
            for(const contractor of ted.contractors){
                description += contractor + "\n"
            }
        }
    
    
        if(ted.value != null){
            description += "Total value: " + ted.value + "\n"
        }
        
        return(

        <>
            <TextField inputRef={linkRef} placeholder="link" sx={{ width: 8/10 }} defaultValue={ted.link} />
            <OpenInNewIcon onClick={handleOpenInNewClicked} />
            <br/>
            <TextField multiline inputRef={titleRef} sx={{ width: 10 / 10}} placeholder="title" defaultValue={ted.title} />
            <TextField inputRef={dateRef} placeholder="date" sx={{ width: 2 / 10}} defaultValue={formatTEDDate(ted.date)}/>
            <TextField disabled={true} sx={{ width: 5 / 10}} value={ ted.type }/>
            <Select inputRef={typeRef} defaultValue={ ted.type == "Contract award"?"Contract award":"Call for tenders" } sx={{ width: 3 / 10}}>
                <MenuItem value="Call for tenders">Call for tenders</MenuItem>
                <MenuItem value="Contract award">Contract award</MenuItem>
            </Select>
            <TextField multiline maxRows={10} inputRef={descriptionRef} defaultValue={description} sx={{ width: 10/10 }} />
            {
                isInStoryline == null?(<Typography>Checking for duplicates...<CircularProgress /></Typography>):(isInStoryline?<Typography color="error"><WarningIcon/>Link is alredy in the storyline</Typography>:<Typography>Link is not in the storyline</Typography>)
            }
            <Button onClick={handleCreate}>Create</Button>
            <Button onClick={() => {handleCloseAndDelete(ted)}}>Delete</Button>
            <Button onClick={handleClose}>Close</Button>
        </>
    )
}